import styled from 'styled-components';

import { ColorScheme } from 'ia-react-core/~/interfaces/ColorScheme';
import media from '../../../utils/styling/media';

import COLOR_SCHEMES from '../../../constants/COLOR_SCHEMES';

export const StyledFooter = styled.footer<{
  scheme: ColorScheme;
}>`
  min-width: ${({ theme }) => theme.layout.minContentWidth}px;
  background: ${({ theme, scheme }) => {
    if (theme.layout.footerBackground) {
      return theme.layout.footerBackground;
    }

    return scheme === COLOR_SCHEMES.SHADE ? theme.colors.white : theme.colors.gray1;
  }};
`;

export const StyledFooterContainer = styled.div<{
  alignWithContent: boolean;
}>`
  max-width: ${({ theme, alignWithContent }) => (
    (!alignWithContent && theme.layout.maxFooterContentWidth) ? theme.layout.maxFooterContentWidth : (theme.layout.maxContentWidth)
  )}px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.layout.footerPadding};

  ${media.lg`
    padding: ${({ theme }) => theme.layout.lgFooterPadding};
  `}
`;

export const StyledFooterSlogan = styled.h2`
  color: ${({ theme }) => theme.colors.gray6};
  font-weight: 700;
  font-family: ${({ theme }) => theme.fontFamily.special};
  margin: 0 0 36px 0;
`;

export const StyledFooterCopyright = styled.small`
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 12px;
  font-weight: 300;
`;
export const StyledInlineSloganWrapper = styled.div`
  display: flex;

  flex-direction: column-reverse;
  justify-content: space-between;

  ${media.sm`
  flex-direction: row;
  `}
`;

export const StyledInlineSloganButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 36px;

  ${media.sm`
    margin-bottom: 0px;
  `}
`;
